import { jsx as _jsx } from "react/jsx-runtime";
import { shallowEqual, useSelector } from 'react-redux';
import { QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import TransactionDescriptionBanner from '../../../../ui/molecules/TransactionDescriptionBanner';
var QuestionnaireBanner = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), step = _a.questionnaire.step, merchantDesc = _a.transactionData.merchantDesc;
    if (step === QuestionnaireFlow.Start ||
        step === QuestionnaireFlow.InProgress ||
        step === QuestionnaireFlow.ContactFraud ||
        step === QuestionnaireFlow.End ||
        step === QuestionnaireFlow.Exit ||
        step === QuestionnaireFlow.Review ||
        step === QuestionnaireFlow.RedisputeReview) {
        return _jsx(TransactionDescriptionBanner, { description: merchantDesc });
    }
    return null;
};
export default QuestionnaireBanner;
//# sourceMappingURL=index.js.map